export const createVoucherSale = () => {
  return {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    name: '',
    voucherTypeId: null,
    voucherPackageId: null,
    voucherTypeName: '',
    voucherTypePrice: 0,
    hasMinimumAmount: false,
    minimumAmount: 1
  }
}
